import Cookies from 'js-cookie'

const LEGAL_LANGS = [
  'zh-TW',
  'en'
]

const state = {
  lang: null
}

export const actions = {
  changeLocale (store, lang) {
    if (!LEGAL_LANGS.includes(lang)) return

    Cookies.set('lang', lang)
    window.location.reload()
  },
  initLocale ({ commit }) {
    const lang = Cookies.get('lang')
    if (!lang) return
    commit('SET_LANG', lang)
  }
}

const mutations = {
  SET_LANG (state, value) {
    state.lang = value
  }
}

export default {
  namespaced: true,
  actions,
  state,
  mutations
}
